/* Doodle Dreams – turn two ordinary items into the actual Shopify Duo product.
 * The checkout price comes from Shopify Bundles, never a frontend-only discount.
 * Only runs after cart updates; includes guards against repeated conversions. */
(function () {
 if (window.__ddCartBundleUpgradeInstalled) return;
 window.__ddCartBundleUpgradeInstalled = true;
 const original={blanket:15408450404720,pillow:15408453714288,pyjamas:15417256477040,markers:15408458465648};
 const names={blanket:['cats & dogs','monsters','mushrooms','flowers'],pillow:['cats & dogs','monsters','mushrooms','flowers'],pyjamas:['girl','boy']};
 const matrix={
  blanket:[[67705968198000,67705992642928,67705992675696,67705992708464],[67705992741232,67705992774000,67705992806768,67705992839536],[67705992872304,67705992905072,67705992937840,67705992970608],[67705993003376,67705993036144,67705993068912,67705993101680]],
  pillow:[[67705968263536,67705998246256,67705998279024,67705998311792],[67705998344560,67705998377328,67705998410096,67705998442864],[67705998475632,67705998508400,67705998541168,67705998573936],[67705998606704,67705998639472,67705998672240,67705998705008]],
  pyjamas:[[67705968787824,67705999982960],[67706000015728,67706000048496]],
  markers:67705968886128
 };
 let active=false;
 let generation=0;
 let rerunRequested=false;
 // Shopify Bundles can expose child components as ordinary product IDs in cart.js.
 // Only explicitly added standalone products qualify for an automatic Duo upgrade.
 function isStandalone(line){
   return !line.parent_relationship && !line.parent_key && !line.parent_line_key && !line.bundle_parent;
 }
 async function cartRequest(endpoint,body){
   const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/'+endpoint+'.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)
   });
   const data=await res.json();
   if(!res.ok||data.status)throw Error(data.description||data.message||'Cart update failed');
   return data;
 }
 async function readCart(){
   const res=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{cache:'no-store'});
   if(!res.ok)throw Error('Could not read cart');
   return await res.json();
 }
 function bundleId(kind,variants){
   if(kind==='markers')return matrix.markers;
   if(kind==='pyjamas')return null; // sizes use the new Infinite Options parent below
   const choices=variants.map(item=>(item.variant_title||item.variant_options?.[0]||'').toLowerCase().trim());
   const i=names[kind].indexOf(choices[0]);
   const j=names[kind].indexOf(choices[1]);
   return i>=0&&j>=0?matrix[kind][i][j]:null;
 }
 function pyjamaSelection(line){
   const parts=(line.variant_title||line.variant_options?.join(' / ')||'').split(' / ').map(x=>x.trim());
   if(!['Girl','Boy'].includes(parts[0]) || !['2-3Y','3-4Y','4-5Y','5-6Y','6-7Y','7-8Y','8-9Y'].includes(parts[1]))return null;
   return {style:parts[0],size:parts[1]};
 }
 async function renderCart(){
   const drawer=document.querySelector('cart-drawer');
   if(drawer?.renderContents){
     const url=(window.location.pathname||'/')+'?sections=cart-drawer,cart-icon-bubble';
     const res=await fetch(url,{cache:'no-store'});
     if(!res.ok)throw Error('Unable to reload cart drawer');
     drawer.renderContents({sections:await res.json()});
   } else if(location.pathname.indexOf('/cart')!==-1) {
     window.location.reload();
   }
 }
 async function convertOnce(expectedGeneration){
   const cart=await readCart();
   if(expectedGeneration!==generation || !cart.items?.length)return false;
   for(const kind of ['blanket','pillow','pyjamas','markers']){
     const lines=cart.items.filter(x=>isStandalone(x) && Number(x.product_id)===original[kind] && !(kind==='markers' && x.properties?.['_Doodle Dreams offer']));
     const pieces=[];
     for(const line of lines){for(let i=0;i<Math.min(line.quantity,2);i++)pieces.push(line);}
     if(pieces.length<2)continue;
     let duoVariant=bundleId(kind,pieces.slice(0,2));
     let bundleProperties=null;
     if(kind==='pyjamas') {
       const a=pyjamaSelection(pieces[0]);
       const b=pyjamaSelection(pieces[1]);
       if(!a || !b) continue;
       duoVariant=67715010789744;
       bundleProperties={
         'Pyjama 1 – Style':a.style,
         'Pyjama 1 – Size':a.size,
         'Pyjama 2 – Style':b.style,
         'Pyjama 2 – Size':b.size,
         'Marker':'Doodle Dreams™ Acrylic Marker Set'
       };
     }
     if(!duoVariant)continue;
     // A deletion or quantity change cancels conversions based on older cart data.
     if(expectedGeneration!==generation)return false;
     // Add first; do not remove an original item if the bundle variant cannot be purchased.
     const newLine={id:duoVariant,quantity:1};
     if(bundleProperties)newLine.properties=bundleProperties;
     await cartRequest('add',{items:[newLine]});
     // Update all old line quantities together. This avoids waiting for a
     // separate Shopify network round trip for each removed original item.
     const used=new Map();
     pieces.slice(0,2).forEach(x=>used.set(x.key,(used.get(x.key)||0)+1));
     const updates={};
     for(const [key,qty] of used){
       const originalLine=lines.find(x=>x.key===key);
       updates[key]=Math.max(0,originalLine.quantity-qty);
     }
     // Paid Starter markers are removed in the same update; Duo markers are
     // supplied by its real Shopify Bundles variant and must not be charged.
     if(kind!=='markers'){
       let free=(kind==='blanket'?2:1);
       for(const line of cart.items){
         if(free<=0)break;
         if(Number(line.product_id)!==original.markers || !line.properties?.['_Doodle Dreams offer'] || line.properties?.['_Doodle Dreams source']!==kind) continue;
         const remove=Math.min(free,line.quantity);
         updates[line.key]=Math.max(0,line.quantity-remove);
         free-=remove;
       }
     }
     await cartRequest('update',{updates});
     return true;
   }
   return false;
 }
 let activePromise=null;
 async function normalize(renderAfter=true){
   // A second Add to Cart can arrive while a previous bundle conversion is
   // running. Wait for that conversion rather than briefly showing stale lines.
   if(active){
     rerunRequested=true;
     const priorChange=activePromise ? await activePromise : false;
     const nextChange=await normalize(renderAfter);
     // If the earlier overlapping add already upgraded the bundle, the
     // newest caller still needs to reload the final cart sections.
     return Boolean(priorChange || nextChange);
   }
   active=true;
   const task=(async()=>{
     const expectedGeneration=generation;
     let changed=false;
     try {
       for(let i=0;i<12;i++){
         if(expectedGeneration!==generation)break;
         const did=await convertOnce(expectedGeneration);
         if(!did)break;
         changed=true;
       }
       if(changed && renderAfter)await renderCart();
     }catch(e){
       console.warn('[Doodle Dreams] Automatic bundle upgrade could not complete:',e);
       if(changed && renderAfter){try{await renderCart()}catch{}}
     }
     return changed;
   })();
   activePromise=task;
   try {return await task;}
   finally {
     active=false;
     activePromise=null;
     if(rerunRequested){rerunRequested=false;schedule();}
   }
 }
 // Product-page Starter additions await the final discounted cart BEFORE the
 // drawer is displayed, instead of first showing an unconverted cart snapshot.
 window.ddUpgradeCartBeforeDrawer=function(){return normalize(false);};
 let scheduled=false;
 function schedule(){
   if(active){rerunRequested=true;return;}
   if(scheduled)return;
   scheduled=true;
   Promise.resolve().then(()=>{scheduled=false;normalize();});
 }
 // A cart removal must never trigger a new Duo conversion. An explicit product
 // addition can do so, but only if Shopify reports two standalone products.
 document.addEventListener('dd:cart-mutation-start',()=>{generation++;});
 const subscribeEvents=()=>{
   if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
     subscribe(PUB_SUB_EVENTS.cartUpdate,(event)=>{
       if(event?.source==='product-form' && event.ddBundleCartSettled !== true) schedule();
       else if(event?.source==='cart-items') {
         // The quantity has already been saved by Shopify; only increases
         // may create an automatic Duo.  Deletions/decreases merely invalidate
         // older conversion attempts and keep an empty cart empty.
         if(event.ddQuantityIncrease === true) schedule();
       }
     });
   }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',subscribeEvents,{once:true});
 else subscribeEvents();
})();
